var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1605 10.1467V12.0534H28.2205V14.5907H33.3832V16.4974H28.2205V19.3574H34.1605V21.2641H25.9912V10.1467H34.1605Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4644 10.1467H24.6937V21.2641H22.4644V10.1467Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5496 10.1467L17.2083 21.2641H14.5683L9.88965 10.1467H12.3096L15.859 18.8881L19.1443 10.1467H21.5496Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVie);
export default __webpack_public_path__ + "static/media/icon_vie.fcffa266b7d8b7b71e36787f544ace4c.svg";
export { ForwardRef as ReactComponent };